export enum ProductTypeEnum {
    Product,
    Service
}